define.alias("shared/components/shared/card/body", "calendar/components/shared/card/body");